module.exports = __webpack_public_path__ + "assets/47e4c6c5d0c63e3de7f8286b0a7acacb.png";